import {
  FinancialSettingsEndpoints,
  ICreateCashRegisterDTO,
  IEditCashRegisterDTO,
  IGetCashRegisterResponse,
  IGetCashRegistersDTO,
  IGetCashRegistersResponse,
} from '@/models/financialSettings.model';
import { ApiResponse, httpClient } from '@/utils';

class FinancialSettingsAPI {
  static getCashRegisters(data: IGetCashRegistersDTO): ApiResponse<IGetCashRegistersResponse> {
    return httpClient.get<IGetCashRegistersResponse>(FinancialSettingsEndpoints.CASH_REGISTERS, { params: data });
  }

  static getCashRegister(id: string): ApiResponse<IGetCashRegisterResponse> {
    return httpClient.get<IGetCashRegisterResponse>(`${FinancialSettingsEndpoints.CASH_REGISTERS}/${id}`);
  }

  static createCashRegister(data: ICreateCashRegisterDTO): ApiResponse<IGetCashRegisterResponse> {
    return httpClient.post<IGetCashRegisterResponse>(FinancialSettingsEndpoints.CASH_REGISTERS, data);
  }

  static updateCashRegister({ id, ...data }: IEditCashRegisterDTO): ApiResponse<IGetCashRegisterResponse> {
    return httpClient.put(`${FinancialSettingsEndpoints.CASH_REGISTERS}/${id}`, data);
  }

  static deleteCashRegister(id: string): ApiResponse<IGetCashRegisterResponse> {
    return httpClient.delete(`${FinancialSettingsEndpoints.CASH_REGISTERS}/${id}`);
  }
}

export default FinancialSettingsAPI;
